import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import RowButtons from './../../components/button/RowButtons';
import RowChangeButton from './../../components/button/RowChangeButton';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import ListTable from './../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import TextDate from './../../components/text/TextDate';
import TextAmount from './../../components/text/TextAmount';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const FormList = ({})  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);

  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/admin/form/formactiongroups/');
    if (isResultOk(data, setListError, true)){
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  const onDeleteClick = async (transactionGroupID) => {
    setIsPageLoading(true);
    const data = await apiPostCall(BASE_URL + '/admin/actioncost/remove', {itemID : transactionGroupID});    
    if (isResultOk(data, setCheckErrorItems)){      
      await loadList();
    }
    setIsPageLoading(false);    
  }


  return (    
    <div>      
      <ListHeader title={t("Bréfa form")}/>              
      {/* <div className="text-right"><Link to="/admin/actioncosts/edit?new=true" className="no-print button gray-light icon-plus pointer-edit text-14">{t("Stofna fastan kostnað")}</Link></div> */}
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list}
          colsettings = {['']}
          headers = {[
            t("Aðgerð og bréf"),
          ]}
          columns = {[
            (item) => <>  {item.forms.map((item, index) => (
                <div className="text-changes-list-item" key={index}>
                  <div>
                    <span className="tag tag-color-gray-dark" style={{ marginRight: 20 }}>
                      {item.actionName}
                    </span>
                    <span>
                      {item.forms.map((form, index) => {
                        const isLast = index === item.forms.length - 1;
                        return (
                          <span key={form.formID} className="text-14">
                            <span className="text-blue cursor-pointer">
                              {form.name}
                            </span>
                            {!isLast && <span style={{ margin: '0 10px' }}>|</span>}
                          </span>
                        );
                      })}
                    </span>
                  </div>
                </div>
              ))}</>
          ]}

      />
  </div>
  );
};
        
